<template>
    <div class="container-fluid container-dashboard">
      <div class="form-row" id="dashboard-home">
          <div v-for="(c, i) in cards" :class="'form-group col-md-' + c.columns" :id="c.component" :i="i">
              <dashboard-card :card="c"></dashboard-card>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import dashboardCard from '@/components/tools/DashboardCard';
  import Vue from 'vue';
  export default {
      name: 'dashboard',
      props: ['cards'],
      components: {
          'dashboard-card': dashboardCard,
      },
  }
  </script>
  